import React from "react";
import { useTranslation } from "react-i18next";
import Modal from "../../Elements/Modal/Modal";
import SecondButton from "../../Elements/SecondButton/SecondButton";
import "./EsimCheckModal.css";

const EsimCheckModal = ({ isOpen, onClose }) => {
  const { t } = useTranslation();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={t("esimCheck.title")}
      actions={
        <>
          <SecondButton onClick={onClose}>{t("common.close")}</SecondButton>
        </>
      }
    >
      <div className="esim-check-modal-body">
        <p className="esim-check-text">{t("esimCheck.step1")}</p>
        <p className="esim-check-text">
          {t("esimCheck.step2")}
        </p>
        <p className="esim-check-text">
          {t("esimCheck.step3")}
        </p>
        <p className="esim-check-hint text-muted">
          {t("esimCheck.hint")}
        </p>
      </div>
    </Modal>
  );
};

export default EsimCheckModal;
